import { gql } from 'graphql-request';
import { useContext } from 'solid-js';
import { AppContext } from '../../app-context-provider/app-context-provider';
import { formStore } from './registration-form-store';
import { RegistrationForm, UserServiceResponse } from './registration-form';
import { medicalFields } from './fields';
import { Heading } from '../../ui-components/heading/heading';
import { MailIcon } from '../icons-library/mail-icon';

export const createUserMutation = gql`
    mutation createUser(
        $email: String!
        $firstName: String
        $lastName: String
        $country: String
        $city: String
        $userType: String!
        $institution: String
        $password: String!
        $clientOrigin: String!
        $verifyAccountUrl: String!
        $referer: String!
        $siteCountry: String
        $captchaToken: String!
        $showpadCode: String
        $company: String
        $redirectState: String
    ) {
        createUser(
            email: $email
            firstName: $firstName
            lastName: $lastName
            country: $country
            city: $city
            userType: $userType
            institution: $institution
            password: $password
            clientOrigin: $clientOrigin
            verifyAccountUrl: $verifyAccountUrl
            referer: $referer
            siteCountry: $siteCountry
            captchaToken: $captchaToken
            showpadCode: $showpadCode
            company: $company
            redirectState: $redirectState
        ) {
            status
            message
        }
    }
`;

    
export const MedicalRegistrationWrapper = () => {
    const { localize, pageVerifyAccountUrl, siteInfo, graphQlClient } = useContext(AppContext);

    const createUser = async (captchaToken: string, arrivedFromUrl?: string): Promise<UserServiceResponse> => {
        const createUserArgs = {
            verifyAccountUrl: pageVerifyAccountUrl,
            siteCountry: siteInfo.country || '',
            clientOrigin: window.location.origin,
            referer: window.location.href,
            email: formStore.fields.email,
            firstName: formStore.fields.firstname,
            lastName: formStore.fields.lastname,
            country: formStore.fields.country,
            city: formStore.fields.city,
            password: formStore.fields.password,
            userType: formStore.fields[ 'user-type' ],
            showpadCode: formStore.fields.showpadCode,
            company: formStore.fields.company,
            captchaToken,
            redirectState: arrivedFromUrl,
        };

        return await graphQlClient(createUserMutation, createUserArgs, false);
    };

    const SuccessMessageComponents = () => {
        const successRegisteringUser = localize('registration-successful', 'Successfully created user account.');
        const message = localize('check-email-cta', 'Please check your email for a verification link.');

        return (
            <div class='text-center'>
                <Heading tag='h4' variant='smallGray' noBlockSpacing>
                    {`${successRegisteringUser}<br/>${message}`}
                </Heading>
            </div>
        );
    };

    return (
        <RegistrationForm
            createUser={(captchaToken, arrivedFromUrl) => createUser(captchaToken, arrivedFromUrl)}
            fields={medicalFields}
            successMessageComponents={<SuccessMessageComponents/>}
            successIcon={<MailIcon width="100%" height="100%" />}
            isAtosCareSite={false}
        />
    );
};
